import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { verifyAndActivateMfa } from 'src/api/lib/mfa';

export const useVerifyAndActivateMfa = (onSuccess?: () => void) => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({
      secret,
      mfaCode,
    }: {
      secret: string;
      mfaCode: string;
    }) => verifyAndActivateMfa(secret, mfaCode),
    onSuccess: () => {
      onSuccess?.();

      toast.success(t('common:mfaActivationSuccess'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
